import EndpointsBase from "../EndpointsBase";

class SettingsEndpoints extends EndpointsBase {
  getPackagingTypes() {
    return this._sendRequest({
      method: "settings/getpackagingtypes",
      data: {},
      run: this.server.getData,
    });
  }
  setPackagingTypes(types: Record<string, number>) {
    return this._sendRequest({
      method: "settings/setpackagingtypes",
      data: { types },
      run: this.server.postData,
    });
  }
  getPackagingTypeForConveyor(conveyorID: string) {
    return this._sendRequest({
      method: "settings/getpackagingtypeforconveyor",
      data: { conveyorID },
      run: this.server.getData,
    });
  }
}

export default new SettingsEndpoints();
